/******************************************************
 *                  Open-iti import
 ********************************************************/

"use strict";

angular.module("exploitation")
	.controller( "ImportNetexParametersCtrl", ["$scope", function ($scope) {
		$scope.data = {
			description: "",
			cleanMode: "",
			keepBoardingAlightingPossibility: "false",
			keepStopGeolocalisation: "false",
			keepStopNames: "true",
			netexImportLayouts: false,
			netexImportColors: false
		};
	}]);